import { jsx as _jsx, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { FacebookConnectionProvider } from '@stepstone/social-auth-components';
import { useAppSelector } from '../hooks/redux/index.js';
import { isFacebookEnabledSelector } from '../core/siteConfig/siteConfigSlice.js';
// this looks suspicious - why are we wrapp all social buttons in FacebookConnectionProvider?
// also we read that selector in fb button anyway to hide it
export const SocialAuthProvider = ({ children, }) => {
    const isFacebookEnable = useAppSelector(isFacebookEnabledSelector);
    return isFacebookEnable ? (_jsx(FacebookConnectionProvider, { children: children })) : (_jsx(_Fragment, { children: children }));
};
//# sourceMappingURL=SocialAuthProvider.js.map